"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var uniqueId_1 = __importDefault(require("../../util/uniqueId"));
var facialHair_1 = __importDefault(require("./facialHair"));
var react_1 = require("react");
var NoHair = function (_a) {
    var children = _a.children;
    var filter1 = react_1.useMemo(function () { return uniqueId_1.default('react-filter-'); }, []);
    var mask1 = react_1.useMemo(function () { return uniqueId_1.default('react-mask-'); }, []);
    var path1 = react_1.useMemo(function () { return uniqueId_1.default('react-path-'); }, []);
    return (jsx_runtime_1.jsxs("g", __assign({ strokeWidth: '1', fillRule: 'evenodd' }, { children: [jsx_runtime_1.jsxs("defs", { children: [jsx_runtime_1.jsx("rect", { id: path1, x: '0', y: '0', width: '264', height: '280' }, void 0),
                    jsx_runtime_1.jsxs("filter", __assign({ x: '-0.8%', y: '-2.0%', width: '101.5%', height: '108.0%', filterUnits: 'objectBoundingBox', id: filter1 }, { children: [jsx_runtime_1.jsx("feOffset", { dx: '0', dy: '2', in: 'SourceAlpha', result: 'shadowOffsetOuter1' }, void 0),
                            jsx_runtime_1.jsx("feColorMatrix", { values: '0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.16 0', type: 'matrix', in: 'shadowOffsetOuter1', result: 'shadowMatrixOuter1' }, void 0),
                            jsx_runtime_1.jsxs("feMerge", { children: [jsx_runtime_1.jsx("feMergeNode", { in: 'shadowMatrixOuter1' }, void 0),
                                    jsx_runtime_1.jsx("feMergeNode", { in: 'SourceGraphic' }, void 0)] }, void 0)] }), void 0)] }, void 0),
            jsx_runtime_1.jsx("mask", __assign({ id: mask1, fill: 'white' }, { children: jsx_runtime_1.jsx("use", { xlinkHref: '#' + path1 }, void 0) }), void 0),
            jsx_runtime_1.jsx("g", __assign({ mask: "url(#" + mask1 + ")" }, { children: jsx_runtime_1.jsxs("g", __assign({ transform: 'translate(-1.000000, 0.000000)' }, { children: [jsx_runtime_1.jsx(facialHair_1.default, {}, void 0), children] }), void 0) }), void 0)] }), void 0));
};
exports.default = NoHair;
